// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2VNe4","colCheckbox":"styles_colCheckbox__3Du6C"};